module.exports = __webpack_public_path__ + "img/20180815_151538_161.cc6b5df3.jpg";